module.exports = __webpack_public_path__ + "img/Vector_8.e66512e3.svg";